module.exports = __webpack_public_path__ + "static/pemalex_logo-c139cd45b7ee7999006ed3714caf4e59.png";